module.exports = __webpack_public_path__ + "static/media/happythoughts.b195f050.png";